import { InitialVisitVehicleInfoQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/InitialVisitVehicleInfo/InitialVisitVehicleInfoQuery.type';
import { InitialVisitVehicleInfoFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/InitialVisitVehicleInfo/InitialVisitVehicleInfoQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const InitialVisitVehicleInfoQueryOptions = (
  params: InitialVisitVehicleInfoQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['InitialVisitVehicleInfoQueryOptions', params],
    queryFn: () => InitialVisitVehicleInfoFunction(params),
  });
};
